import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { NavHeader } from 'containers'
import { Footer } from 'containers'
import { Banner } from 'components'

export const App: React.FC = () => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <div
      className="flex flex-col min-h-screen bg-cover bg-linear-to-b from-backgroundPrimary from-0% to-backgroundSecondary to-80%"
      data-testid="app-container"
    >
      <Banner />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
      <div className={isHomePage ? 'sticky top-0 z-30' : ''}>
        <NavHeader />
      </div>
      <Outlet />
      <Footer />
    </div>
  )
}
